module.exports = KsysAppTemplateV2dot8dot7;